/** Generated cover art for songs / sounds without a usable cover: a calm gradient picked from a hash of the genre (or title). */

export interface GenreTileColors { from: string; to: string; ink: string }

/** Soft, low-saturation pairs (no neon, no plain grey) with a readable ink colour for the label and glyph. */
const PALETTE: readonly GenreTileColors[] = [
  { from: '#e3efe6', to: '#f4f8f2', ink: '#3f5f4a' }, // sage
  { from: '#dfeaf5', to: '#f3f7fb', ink: '#3b5670' }, // sky
  { from: '#f3e9da', to: '#faf6ef', ink: '#6b5536' }, // sand
  { from: '#e9e4f5', to: '#f6f4fb', ink: '#54487a' }, // lavender
  { from: '#f4e3e6', to: '#fbf4f5', ink: '#7a4450' }, // rose
  { from: '#dcefee', to: '#f2f9f8', ink: '#2f5f5c' }, // teal
  { from: '#f6e6dc', to: '#fcf5f0', ink: '#7a4f36' }, // peach
];

/** Stable string hash (djb2). */
function hash(s: string): number {
  let h = 5381;
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) >>> 0;
  return h;
}

/**
 * Same key (the genre, or the title when there is no genre) → same colours, case- and spacing-insensitive.
 * No key at all → lavender, so a placeholder never reads as a flat grey square.
 */
export function genreTileColors(key: string | null | undefined): GenreTileColors {
  const k = (key ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  if (!k) return PALETTE[3];
  return PALETTE[hash(k) % PALETTE.length];
}
